/* global Office */

interface ContextInfo {
  isOffice: boolean;
  isOutlook: boolean;
  isBrowser: boolean;
  platform: "web" | "desktop" | "ios" | "android" | "unknown";
}

export const getContextInfo = (): ContextInfo => {
  const defaultContext: ContextInfo = {
    isOffice: false,
    isOutlook: false,
    isBrowser: true,
    platform: "web",
  };

  try {
    if (typeof Office === "undefined") {
      return defaultContext;
    }

    const isOffice = !!Office?.context;
    const isOutlook = isOffice && Office.context.mailbox !== undefined;

    let platform: ContextInfo["platform"] = "unknown";
    if (Office.context.platform) {
      switch (Office.context.platform) {
        case Office.PlatformType.PC:
          platform = "desktop";
          break;
        case Office.PlatformType.OfficeOnline:
          platform = "web";
          break;
        case Office.PlatformType.iOS:
          platform = "ios";
          break;
        case Office.PlatformType.Android:
          platform = "android";
          break;
        default:
          platform = "unknown";
      }
    }

    return {
      isOffice,
      isOutlook,
      isBrowser: !isOffice,
      platform,
    };
  } catch (error) {
    return defaultContext;
  }
};

export const isOfficeContext = (): boolean => getContextInfo().isOffice;
export const isOutlookContext = (): boolean => getContextInfo().isOutlook;
export const isBrowserContext = (): boolean => getContextInfo().isBrowser;
